import { Component } from "react"
import PropTypes from "prop-types"

import triggerFieldTypes, {
  findTypeByID,
} from "partners/components/shared/trigger_field_types"
import { StatusRow } from "./table_components"
import PopulatorValue from "./populator_value"

const TYPE_NAME = {
  text_raw: "Text input without validation",
  text_not_blank: "Text input (must not be blank)",
  text_url: "Text input (must be a URL)",
  text_email: "Text input (must be an email address)",
  text_regex: "Text input (must match a custom regex)",
  text_dynamic: "Text input (dynamically validated)",
  dropdown_static: "Dropdown list (populated with specified items)",
  dropdown_dynamic: "Dropdown list (populated dynamically)",
  location_point: "Location (point)",
  location_point_dynamic: "Location (point, validated dynamically)",
  location_radius: "Location (radius)",
  location_radius_dynamic: "Location (radius, validated dynamically)",
  location_enter: "Location (enter an area)",
  location_enter_dynamic: "Location (enter an area, validated dynamically)",
  location_exit: "Location (exit an area)",
  location_exit_dynamic: "Location (exit an area, validated dynamically)",
  location_enter_and_exit: "Location (enter or exit an area)",
  location_enter_and_exit_dynamic:
    "Location (enter or exit an area, validated dynamically)",
}

class TriggerField extends Component {
  renderAttributes() {
    const { triggerField, feedbackItems = {}, diffStyle, pathObjs } = this.props
    let attributes = [
      {
        key: `trigger-field-item-name-${triggerField.id}`,
        name: "Label",
        value: triggerField.name,
        required: true,
        fieldName: "name",
      },
      {
        key: `trigger-field-item-helper-text-${triggerField.id}`,
        name: "Optional helper text",
        value: triggerField.helper_text,
        fieldName: "helper_text",
      },
      {
        key: `trigger-field-item-slug-${triggerField.id}`,
        name: "Key name",
        value: triggerField.slug,
        required: true,
        fieldName: "slug",
      },
      {
        key: `trigger-field-shareable-${triggerField.id}`,
        name: "Private?",
        value: triggerField.shareable,
        fieldName: "shareable",
        transform: value => (value ? "No" : "Yes"),
      },
      {
        key: `trigger-field-item-field-type-${triggerField.id}`,
        name: "Field Type",
        value: triggerField.trigger_field_type,
        transform: value =>
          TYPE_NAME[findTypeByID(value)] || "Unknown Field Type",
        fieldName: "trigger_field_type",
      },
    ]

    if (triggerField.trigger_field_type === 4) {
      attributes = attributes.concat([
        {
          key: `trigger-field-regex-${triggerField.id}`,
          name: "Regex",
          required: true,
          value: triggerField.regex_value,
          fieldName: "regex_value",
        },
        {
          key: `trigger-field-regex_error_message-${triggerField.id}`,
          name: "Regex Error Message",
          required: true,
          value: triggerField.regex_error_message,
          fieldName: "regex_error_message",
        },
      ])
    } else if (triggerField.trigger_field_type === 6) {
      const diffs = this.props.changes.filter(
        diff => diff.path[4] === "populator_values"
      )
      const originalChannel = this.props.originalChannel
      attributes = attributes.concat([
        {
          key: "trigger-field-item-populator-values",
          name: "Dropdown Options",
          value: triggerField.populator_values,
          required: true,
          transform: value => (
            <PopulatorValue
              diffStyle={diffStyle}
              originalChannel={originalChannel}
              values={value}
              changes={diffs}
              parent="triggers"
              collection="trigger_fields"
            />
          ),
          fieldName: "populator_values",
        },
      ])
    }

    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return attributes.map(item => {
      item.feedback = feedbackItems[item.fieldName]
      item.pathObjs = [...this.props.pathObjs, triggerField.id, item.fieldName]
      item.diff = this.props.changes.find(
        diff =>
          diff.data &&
          diff.data.property === item.fieldName &&
          diff.path.length === 4
      )
      if (item.feedback && !submenuIcons.triggersFeedback) {
        this.props.setSessionFeedback("triggers", submenuIcons)
      }
      return this.props.tableRow(item)
    })
  }

  render() {
    return (
      <table className="subtable">
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.renderAttributes()}
        </tbody>
      </table>
    )
  }
}

TriggerField.propTypes = {
  diffStyle: PropTypes.string.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  pathObjs: PropTypes.array.isRequired,
  triggerField: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default TriggerField
